import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { TabError } from '@/utils/class/TabError'
import { getObjectByCache } from '@/utils/basicDataCache'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import * as OverseaAgentGrade from '@/class/cargo/model/parameters/OverseaAgentGrade'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { Company } from '@/class/model/mdm/Company'
import { Contract } from '@/class/model/mdm/Contract'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { Trucking } from '@/class/model/booking/Trucking'
import { TruckingInfo } from '@/class/model/booking/TruckingInfo'
import { getSites, addSites, queryCompanyUserByCompany, checkCompany, queryCompanyCmpIdxByCompanyUser, validateReleaseNumberCustomer } from '@/api/company'
import { checkPoNoIsExist, getCustomerByRole } from '@/api/booking/job'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import { OverseaCustomerUtils } from '@/class/cargo/model/utils/OverseaCustomerUtils'
import { getPartnerByPoNo } from '@/api/projectManage/project'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import StrUtils from '@/utils/StrUtils'
import { canCreateByCreditInfoDetail } from '@/api/partner/creditInfo'
import { IMPERIAL_2 } from '@/class/cargo/model/parameters/SystemConstants'
import $store from '@/store'
import { cache } from '@/utils/cacheManager'

export default {
  methods: {
    async onShow(row, isRefresh) {
      this.currentOffice = this.context.office
      if (!isRefresh) {
        return
      }
      /* ****************************** 初始化 begin ****************************** */
      this.accountObjectControlMode = Number(cache.config.get('AccountObjectControlMode'))
      this.isHc = String(cache.config.get('ToExoSystem')) === 'HC'
      this.salesOfficeCheck = Number(this.context.config.get('SalesOfficeCheck')) === 1
      this.validateCustomerSales = Number(this.context.config.get('BookingValidateCustomerSales')) === 1
      this.isSpecifiedSalesBusiness = Number(this.context.config.get('IsSpecifiedSalesBusiness')) === 1
      this.salesCanSeeBookingAgent = Number(this.context.config.get('SalesCanSeeBookingAgent')) === 1
      this.openProjectConfig = Number(this.context.config.get('openProjectConfig')) === 1
      this.isAddUserDefinedRoles = Number(this.context.config.get('IsAddUserDefinedRoles')) === 1
      this.needConfirmProjectNo = Number(this.context.config.get('needConfirmProjectNo')) === 1
      this.isProjectLinkedCustomer = Number(this.context.config.get('isProjectLinkedCustomer')) === 1 // 项目是否和委托单位关联
      this.splitBubbleCollectionFormat = Number(this.context.config.get('SplitBubbleCollectionFormat')) === 1
      this.cWeightCeil = Number(this.context.config.get('AEcWeightCeil'))
      this.isShowContactPersonDetail = String(this.context.config.get('ToExoSystem')) === 'HC'
      this.hasChooseOwnTransceiverPermission = this.$checkPermission(['role_RemoteBooking_ChooseOwnTransceiver']) && !this.$store.getters.isAdmin
      this.creditOpen = Number(this.context.config.get('creditOpen'))
      this.customerCmpList = []
      this.contactList = []
      this.csrList = null
      this.cargoSalesList = null
      this.salesList = null
      this.txtSalesOffice = ''
      this.doorList = []
      for (const key in this.userPortRoleData) {
        this.userPortRoleData[key] = null
      }
      // 加载英制单位配置
      JobUtils.initImperialData(IMPERIAL_2.code).then(r => {
        this.openImperial = r
      })
      /* ****************************** end ****************************** */
      this.job = row
      row.landTransportation = row.loadingTerm === 'DD'
      if (!row.uuid && row.customerId > 0) {
        const cmp = this.context.companyList.find(p => p.cmpIdx === row.customerId)
        if (cmp) {
          await this.loadCustomerDetail(cmp)
        }
      }
      // 验证销售
      await this.loadCustomerSales()
      const job = this.job
      const office = this.context.officeList.find(p => p.officeId === job.salesOffice)
      this.txtSalesOffice = office ? office.chineseName : ''
      this.loadTrucking()
      this.changeLockSales()
      this.loadSalesPrivateCustomer()
      this.loadPrivateCompanyList()
      if (job.op > 0) {
        const usr = this.context.userList.find(p => p.userId === job.op)
        if (usr) {
          usr.value = job.op
          if (this.action !== 'copy') {
            this.txtOPChangeHandler(usr)
          }
        }
      }
      if (!job.uuid && job.customerId > 0) {
        const company = this.context.companyList.find(p => p.cmpIdx === job.customerId)
        this.txtCustomerId_changeHandler(company || {})
      }
      if (this.action !== 'copy') {
        OverseaCustomerUtils.loadOverseaAgentChanged(this)
      }
      if (!this.isEdit && job.poNo && this.needConfirmProjectNo && !this.openProjectConfig) {
        this.poNoRed = await checkPoNoIsExist(job.poNo, job.uuid).then(res => res.data) > 0
      }
      if (!job.uuid) {
        JobUtils.matchUserPortConfig(this, job, true)
        JobUtils.matchRegionWarehouseMappingConfig(job, null, true, null, null, true)
      } else {
        JobUtils.matchUserPortConfig(this, job, true, null, { keepOriginValue: true })
      }
      this.pbProportionCheck = false
      this.pbProportion2Check = false
      if (job.uuid) {
        JobUtils.loadCompanyCargoSales(this, job, this.isSpecifiedSalesBusiness)
      }
      if (this.$store.getters.enableFrontEndPlugin) {
        this.setOperationDateData()
        this.setUserDefinedRoleData()
      }
    },
    async loadCustomerDetail(company) {
      if (this.isEdit) {
        const customerDetail = await new Company(company).getCustomerDetail()
        if (customerDetail && customerDetail.designated) {
          // 指定货
          this.job.cargoSource = CargoSource.NC_CARGO_SOURCE.code
        } else {
          // 自揽货
          this.job.cargoSource = CargoSource.SC_CARGO_SOURCE.code
        }
      }
      this.contactList = await new Company(company).getContacts()
      if (this.isEdit) {
        this.onCustomerContactLoad()
      }
    },
    onCustomerContactLoad() {
      if (this.contactList && this.contactList.length > 0) {
        const contact = this.getDefaultContact(this.contactList)
        if (contact) {
          this.job.customerContact = contact.contactPerson
          this.job.contactTelephone = contact.telephone
          this.job.contactFax = contact.fax
        }
      }
    },
    /**
     * 获取默认联系人
     */
    getDefaultContact(ary) {
      let rs = null
      if (ary && ary.length > 0) {
        rs = ary[0]
        for (const contact of ary) {
          if (contact.defaultContact) {
            rs = contact
            break
          }
        }
      }
      return rs
    },
    /**
     * 1、是否启用报价委托订舱根据销售验证客户
     * 2、是否启用合作伙伴对应的服务人员设置
     * 全部满足才能编辑销售
     */
    async loadCustomerSales() {
      if (this.isSpecifiedSalesBusiness && this.job.customerId > 0) {
        const cmp = this.context.companyList.find(p => p.cmpIdx === this.job.customerId)
        if (cmp) {
          const companyUsers = await Company.getCompanyUsers(cmp.uuid)
          await this.loadCustomerSalesHandler(companyUsers)
        }
      }
    },
    async loadCustomerSalesHandler(companyUsers) {
      const job = this.job
      // 销售
      let salesList = []
      // 如果开启分公司过滤参数，查出来所有分公司
      let officeSaleList = []
      if (this.salesOfficeCheck) {
        officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.$store.getters.currentOfficeId)
      }
      if (companyUsers && companyUsers.length > 0) {
        for (const u of companyUsers) {
          if (!u.lob || u.lob === job.lob || u.lob === 'ALL') {
            const user = this.context.userList.find(p => p.userId === u.userId)
            if (user) {
              if (u.roleType === CargoOfRoleType.SALES_TYPE.code) { // 销售
                if (this.salesOfficeCheck) {
                  for (const obj of officeSaleList) {
                    if (user.userId === obj.userId) {
                      if (this.validateCustomerSales && u.userId === this.context.user.userId) {
                        salesList = [user, ...salesList]
                      } else {
                        salesList.push(user)
                      }
                    }
                  }
                } else {
                  if (this.validateCustomerSales && u.userId === this.context.user.userId) {
                    salesList = [user, ...salesList]
                  } else {
                    salesList.push(user)
                  }
                }
              }
            }
          }
        }
      }
      this.salesList = salesList
    },
    loadTrucking() {
      const job = this.job
      if (job.trucking.length === 0) {
        const truckingInfo = new Trucking().fillDefaultValue().getData()
        truckingInfo.loadingPortService = true
        truckingInfo.jobUuid = job.uuid
        truckingInfo.truckOrderNo = JobUtils.createTruckOrderNo(job)
        job.trucking.push(truckingInfo)
      }
      this.truckingInfo = job.trucking[0]
      this.addTruckingToModifiedSet(this.truckingInfo)
      job.carryingCmp = this.truckingInfo.carryingCmp
      this.loadSites()
    },
    changeLockSales() {
      const user = this.context.user
      if (this.validateCustomerSales && user.userId !== 250000 && !user.admin) {
        if (!this.job.uuid) {
          this.job.sales = user.userId
          this.lockSales = true
          this.txtSales_changeHandler({ ...user, value: user.userId })
        } else {
          this.lockSales = true
        }
      }
    },
    // 外部销售只能加载自己的客户
    async loadSalesPrivateCustomer() {
      this.customerCmpList = null
      if (this.isSpecifiedSalesBusiness && this.$checkPermission(['role_RemoteBooking_queryPrivateCustom']) && !this.context.user.admin) {
        await queryCompanyUserByCompany({ userId: this.context.user.userId, roleType: 2, lob: 'AE' }).then(res => {
          this.customerCmpList = this.context.companyList.filter(p => res.data.includes(p.uuid))
        })
        // if (this.isHc) {
        //   // 查看 当前登录用户所关联的合作伙伴（与上面集合 取并集）
        //   this.customerCmpList = await Company.unionAllUserRoleCompany(this.$store.getters.currentOfficeId,
        //       this.$store.getters.userId, 'AE', this.customerCmpList, this.context.companyList)
        // }
      } else if (!this.context.user.admin && (this.$checkPermission(['role_SalesQueryModule_salesCustomer']) || this.$checkPermission(['role_SalesQueryModule_departmentCustomer']))) {
        await getCustomerByRole({ branch: this.$store.getters.currentOfficeId }).then(res => {
          this.customerCmpList = this.context.companyList.filter(p => res.data.includes(p.cmpIdx))
        })
        // if (this.isHc) {
        //   // 查看 当前登录用户所关联的合作伙伴（与上面集合 取并集）
        //   this.customerCmpList = await Company.unionAllUserRoleCompany(this.$store.getters.currentOfficeId,
        //       this.$store.getters.userId, 'AE', this.customerCmpList, this.context.companyList)
        // }
      }
    },
    // 加载服务人员关联的客户或创建人是自己的合作伙伴
    loadPrivateCompanyList() {
      this.privateShipperList = []
      this.privateConsigneeList = []
      this.privateNotifyList = []
      if (this.isSpecifiedSalesBusiness && this.hasChooseOwnTransceiverPermission) {
        queryCompanyCmpIdxByCompanyUser({ userId: this.context.user.userId, lob: 'SE' }).then(res => {
          this.privateShipperList = this.context.companyList.filter(p => (res.data.includes(p.uuid) || p.createdBy === this.context.user.userId) &&
              p.active && p.airExport && p.shipper && (p.branchId === this.$store.getters.currentOfficeId || p.branchId === 1))
          this.privateConsigneeList = this.context.companyList.filter(p => (res.data.includes(p.uuid) || p.createdBy === this.context.user.userId) &&
              p.active && p.airExport && p.consignee && (p.branchId === this.$store.getters.currentOfficeId || p.branchId === 1))
          this.privateNotifyList = this.context.companyList.filter(p => (res.data.includes(p.uuid) || p.createdBy === this.context.user.userId) &&
              p.active && p.airExport && p.notify && (p.branchId === this.$store.getters.currentOfficeId || p.branchId === 1))
        })
      }
    },
    customsBrokerFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.customsBroker && item.seaExport && item.active
    },
    // 门店地址
    async loadSites() {
      let cmp = null
      if (this.job.customerId > 0) {
        cmp = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', this.job.customerId)
      }
      this.doorList = []
      if (cmp) {
        await getSites(cmp.uuid).then(res => {
          const keySet = new Set()
          for (const item of res.data) {
            if (keySet.has(item.name)) {
              continue
            }
            this.doorList.push(item)
            keySet.add(item.name)
          }
        })
      }
      // 编辑业务时，如果门点是新增的，”门点“没有维护，清空门点相关信息
      if (!this.truckingInfo.uuid && this.isEdit) {
        const door = this.doorList.find(p => p.name === this.truckingInfo.doorName)
        if (!door) {
          this.truckingInfo.doorName = ''
          this.truckingInfo.doorMan = ''
          this.truckingInfo.doorManTel = ''
          this.truckingInfo.doorAddr = ''
        }
      }
    },
    loadingTerm_Change(fieldName) {
      const job = this.job
      if (fieldName === 'warehousing') {
        if (!job.warehousing) {
          job.warehouseCmp = 0
          if (job.warehouseInfo && job.warehouseInfo.length > 0) {
            for (const item of job.warehouseInfo) {
              if (item.uuid) {
                item.jobUuid = ''
                this.addWarehouseToModifiedSet(item)
              } else {
                this.removeWarehouseFromModifiedSet(item)
              }
            }
          }
        }
      } else if (fieldName === 'landTransportation') {
        if (!job.landTransportation) {
          job.carryingCmp = 0
          // 取消勾选客户门点/提货，清空客户门点页签信息
          if (job.trucking && job.trucking.length > 0) {
            for (const item of job.trucking) {
              if (item.uuid) {
                item.jobUuid = ''
                this.addTruckingToModifiedSet(item)
              } else {
                this.removeTruckingFromModifiedSet(item)
              }
            }
          }
          this.truckingInfo.doorName = ''
          this.truckingInfo.doorMan = ''
          this.truckingInfo.doorManTel = ''
          this.truckingInfo.doorAddr = ''
        } else {
          this.truckingInfo.jobUuid = this.job.uuid
        }
      }
    },
    // 添加warehouseInfo到被修改的集合中
    addWarehouseToModifiedSet(warehouse) {
      const modifiedData = this.context.modifiedData
      modifiedData.warehouseInfo = modifiedData.warehouseInfo || []
      if (!modifiedData.warehouseInfo.includes(warehouse)) {
        modifiedData.warehouseInfo.push(warehouse)
      }
    },
    // 将warehouseInfo从被修改的集合中移除
    removeWarehouseFromModifiedSet(warehouse) {
      const modifiedData = this.context.modifiedData
      if (modifiedData.warehouseInfo && modifiedData.warehouseInfo.includes(warehouse)) {
        const index = modifiedData.warehouseInfo.indexOf(warehouse)
        if (index > -1) {
          modifiedData.warehouseInfo.splice(index, 1)
        }
      }
    },
    // 添加truckingInfo到被修改的集合中
    addTruckingToModifiedSet(truckingInfo) {
      const modifiedData = this.context.modifiedData
      modifiedData.truckingInfo = modifiedData.truckingInfo || []
      if (!modifiedData.truckingInfo.includes(truckingInfo)) {
        modifiedData.truckingInfo.push(truckingInfo)
      }
    },
    // 将truckingInfo从被修改的集合中移除
    removeTruckingFromModifiedSet(truckingInfo) {
      const modifiedData = this.context.modifiedData
      if (modifiedData.truckingInfo && modifiedData.truckingInfo.includes(truckingInfo)) {
        const index = modifiedData.truckingInfo.indexOf(truckingInfo)
        if (index > -1) {
          modifiedData.truckingInfo.splice(index, 1)
        }
      }
    },
    async txtCustomerId_changeHandler(company) {
      this.cargoSalesList = null
      if (company.cmpIdx > 0) {
        const validateRes = await validateReleaseNumberCustomer({
          companyId: company.cmpIdx,
          officeId: this.$store.getters.currentOfficeId
        })
        if (validateRes && validateRes.data && validateRes.data.allowed === false) {
          if (validateRes.data.message) {
            this.$message.warning(validateRes.data.message)
          }
          this.job.customerId = 0
          return
        }
        // 中邮委托单位是否黑名单
        const blacklist = await JobUtils.checkBlacklistByCustomerId(company.cmpIdx)
        if (blacklist) {
          // return
        }
        const isForbid = await Contract.isContractExpiredForbidCreateJob(company.cmpIdx)
        if (isForbid) {
          this.job.customerId = 0
          this.$message.info(this.$t('Message.ContractExpireCannotCreated'))
          return
        }

        // 合同限制校验：检查是否启用合同限制且可放号天数<=0
        const contractLimitEnabled = company.contractLimitEnabled
        const availableDays = company.availableReleaseDays

        // contractLimitEnabled 可能是 '1' 或 1
        if (contractLimitEnabled === '1' || contractLimitEnabled === 1) {
          // availableReleaseDays 可能是数字或字符串，需要转换
          const daysNum = parseInt(availableDays) || 0
          if (daysNum <= 0) {
            const companyName = company.chineseName || company.englishName || '该委托单位'
            this.$message.warning(`${companyName} 未上传合同/合同失效，无法放号，请联系客户管理人员`)
            this.job.customerId = 0
            return
          }
        }

        if (this.job.customerId && parseInt(this.job.customerId) > 0) {
          this.job.preCustomerId = this.job.customerId
        }
        this.context.reloadCharge = SEUtils.refreshChargeAccountId(this.job, 'customerId', this.$t('SeaExport.ConsignationCompany'), this.context.modifiedData) // 这里返回true，说明修改了费用结算对象以及开票抬头，需要将费用参与保存
        this.job.customerId = company.cmpIdx
        await this.loadCustomerDetail(company)
        if (this.creditOpen) {
          await this.checkNewJobCreditInfo()
        }
        if (this.context.user.admin || !this.validateCustomerSales) {
          this.customerIdChangeHandler(company)
        } else {
          checkCompany({ sales: this.context.user.userId, companyUuid: company.uuid }).then(res => {
            if (res.data) {
              this.customerIdChangeHandler(company)
            } else {
              this.$confirm(this.$t('CargoMsg.Cargo_TheClientDoesNotBelongToYourCustomerTips'), this.$t('common.tips.prompt'), {
                confirmButtonText: this.$t('common.btn.ok'),
                showCancelButton: false,
                showClose: false,
                closeOnClickModal: false,
                type: 'warning'
              }).then(() => {
                const job = this.job
                job.customerId = 0
                job.contactTelephone = ''
                job.contactFax = ''
                job.customerContact = ''
                this.contactList = []
              }).catch()
            }
          })
        }
      } else {
        this.job.customerId = 0
        this.job.cargoSalesId = 0
        if (this.job.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
          this.txtSalesOffice = ''
          this.job.sales = 0
          this.salesList = null
        }
      }
      JobUtils.loadCompanyCargoSales(this, this.job, this.isSpecifiedSalesBusiness, true)
    },
    customerIdChangeHandler(company) {
      if (this.isSpecifiedSalesBusiness) {
        this.loadCompanyUser(company)
      } else {
        this.changeCustomerId()
      }
    },
    /**
   * 按业务指定销售
   */
    loadCompanyUser(company) {
      if (company) {
        Company.getCompanyUsers(company.uuid).then(data => {
          this.loadCompanyUserHandler(data)
        })
      } else {
        this.salesList = null
      }
    },
    async loadCompanyUserHandler(companyUsers) {
      const job = this.job
      // 销售
      let salesList = []
      let salesDefaultId = 0
      // 客服
      const csrList = []
      let csrDefaultId = 0
      // 揽货销售
      const cargoSalesList = []
      let cargoSalesId = 0
      // 操作
      const opList = []
      let opDefaultId = 0
      // 海外客服
      const overseaOpList = []
      let overseaOpDefaultId = 0
      // 单证
      const dcList = []
      let dcDefaultId = 0
      // 如果开启分公司过滤参数，查出来所有分公司
      let officeSaleList = []
      if (this.salesOfficeCheck) {
        officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.$store.getters.currentOfficeId)
      }
      if (companyUsers && companyUsers.length > 0) {
        for (const u of companyUsers) {
          if (!u.lob || u.lob === job.lob || u.lob === 'ALL') {
            const user = this.context.userList.find(p => p.userId === u.userId)
            if (user && user.active) {
              if (u.roleType === CargoOfRoleType.SALES_TYPE.code) { // 销售
                if (this.salesOfficeCheck) {
                  for (const obj of officeSaleList) {
                    if (user.userId === obj.userId) {
                      if (u.defaultUser) {
                        salesDefaultId = u.userId
                      }
                      if (this.validateCustomerSales && u.userId === this.context.user.userId) {
                        salesList = [user, ...salesList]
                      } else {
                        salesList.push(user)
                      }
                    }
                  }
                } else {
                  if (u.defaultUser) {
                    salesDefaultId = u.userId
                  }
                  if (this.validateCustomerSales && u.userId === this.context.user.userId) {
                    salesList = [user, ...salesList]
                  } else {
                    salesList.push(user)
                  }
                }
              } else if (u.roleType === CargoOfRoleType.CSR_TYPE.code) { // 客服
                if (u.defaultUser) {
                  csrDefaultId = u.userId
                }
                csrList.push(user)
              } else if (u.roleType === CargoOfRoleType.SALES_OF_GOODS.code) { // 揽货销售
                if (u.defaultUser) {
                  cargoSalesId = u.userId
                }
                cargoSalesList.push(user)
              } else if (u.roleType === CargoOfRoleType.OP_TYPE.code) { // 操作
                if (u.defaultUser) {
                  opDefaultId = u.userId
                }
                opList.push(user)
              } else if (u.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code) { // 海外客服
                if (u.defaultUser) {
                  overseaOpDefaultId = u.userId
                }
                overseaOpList.push(user)
              } else if (u.roleType === CargoOfRoleType.DOC_TYPE.code) { // 单证
                if (u.defaultUser) {
                  dcDefaultId = u.userId
                }
                dcList.push(user)
              }
            }
          }
        }
      }
      if (this.isSpecifiedSalesBusiness) {
        this.salesList = salesList
        if (salesList.length > 0) {
          if (salesDefaultId > 0) {
            if (!this.validateCustomerSales) {
              job.sales = salesDefaultId
            } else {
              job.sales = salesList[0].userId
            }
          } else {
            job.sales = salesList[0].userId
          }
          this.$nextTick(() => {
            const user = this.context.userList.find(p => p.userId === job.sales)
            this.txtSales_changeHandler({ ...user, value: user.userId })
          })
        }
        // 客服
        if (csrList.length > 0) {
          if (csrDefaultId > 0) {
            job.csr = csrDefaultId
          } else {
            job.csr = csrList[0].userId
          }
          if (job.csr) {
            this.$nextTick(() => {
              const user = this.context.userList.find(p => p.userId === job.csr)
              this.csrChangeHandler({ ...user, value: user.userId })
            })
          }
        }
        // 揽货销售
        if (cargoSalesList.length > 0) {
          if (cargoSalesId > 0) {
            job.cargoSalesId = cargoSalesId
          } else {
            job.cargoSalesId = cargoSalesList[0].userId
          }
          this.$nextTick(() => {
            const user = this.context.userList.find(p => p.userId === job.cargoSalesId)
            this.cargoSalesChargeHandler({ ...user, value: user.userId })
          })
        } else {
          // job.cargoSalesId = 0
          // job.cargoSalesOffice = 0
          // job.cargoSalesDepartment = 0
        }
        if (this.isHc) {
          // 操作
          if (opList.length > 0) {
            if (opDefaultId > 0) {
              job.op = opDefaultId
            } else {
              job.op = opList[0].userId
            }

            const user = await User.getUserById(job.op)
            this.$nextTick(() => {
              this.txtOPChangeHandler({ ...user, value: user.userId })
            })
          } else {
            // job.op = 0
            // job.opDepartment = 0
          }
          // 海外客服
          if (overseaOpList.length > 0) {
            if (overseaOpDefaultId > 0) {
              job.overseaOp = overseaOpDefaultId
            } else {
              job.overseaOp = overseaOpList[0].userId
            }

            const user = await User.getUserById(job.overseaOp)
            this.$nextTick(() => {
              OverseaCustomerUtils.overseaOpChangeHandler(this, { ...user, value: user.userId })
            })
          } else {
            // job.overseaOp = 0
            // job.overseaOpDepartment = 0
          }
        }

        // 单证
        if (dcList.length > 0) {
          if (dcDefaultId > 0) {
            job.dc = dcDefaultId
          } else {
            job.dc = dcList[0].userId
          }
          if (job.dc) {
            this.$nextTick(() => {
              const user = this.context.userList.find(p => p.userId === job.dc)
              this.dcChangeHandler({ ...user, value: user.userId })
            })
          }
        }
      }
      const chk = this.checkCustomerSales()
      if (!chk) {
        this.$message.warning('亲，只能选择销售所关联的客户(⊙o⊙)哦')
        this.job.customerId = 0
        return
      }
      this.loadSites()
    },
    checkCustomerSales() {
      if (!this.validateCustomerSales || !this.salesList || this.salesList.length === 0 || this.job.sales <= 0) {
        return true
      }
      for (const u of this.salesList) {
        if (u.userId === this.job.sales) {
          return true
        }
      }
      return false
    },
    changeCustomerId() {
      this.getCustmerSales()
      this.loadSites()
    },
    tfLinkman_closeHandler() {
      const contact = this.contactList.find(p => p.contactPerson === this.job.customerContact)
      if (contact) {
        this.job.contactTelephone = contact.telephone
        this.job.contactFax = contact.fax
      }
    },
    // 客服改变
    async csrChangeHandler(data) {
      const job = this.job
      job.csr = data.value
      job.csrDepartment = 0
      job.csrOffice = 0
      if (data.value) {
        if (data.defaultDepId && data.defaultOfficeId && job.opOffice === data.defaultOfficeId) {
          job.csrOffice = data.defaultOfficeId
          job.csrDepartment = data.defaultDepId
        } else {
          const offices = await User.getUserDepartmentOffices('role', 'csr', data.value)
          if (offices && offices.length > 1) {
            for (const item of offices) {
              if (item.officeId === $store.getters.currentOfficeId) {
                const office = await Office.getOfficeById(item.officeId)
                job.csrOffice = office ? office.officeId : 0
                job.csrDepartment = item.departmentId
                break
              }
            }
          } else {
            const user = new User(data)
            const dep = await user.getDefaultDepartment('role', 'csr')
            if (dep) {
              job.csrDepartment = dep.departmentId
              const office = await Office.getOfficeByUuid(dep.officeUuid)
              job.csrOffice = office ? office.officeId : 0
            }
          }
        }
      }
    },
    async txtSales_changeHandler(data) {
      const job = this.job
      job.sales = data.value
      job.salesOffice = 0
      this.txtSalesOffice = ''
      job.salesDepartment = 0
      if (data.value) {
        if (data.defaultOfficeId) { // 用户设置了默认公司和部门就用默认的
          job.salesOffice = data.defaultOfficeId
          job.salesDepartment = data.defaultDepId
          const office = await Office.getOfficeById(job.salesOffice)
          this.txtSalesOffice = this.isZh ? office.chineseName : office.englishName
        } else {
          const offices = await User.getUserDepartmentOffices('role', 'sales', data.value)
          if (offices.length > 1) {
            for (const item of offices) {
              if (this.branchOfficeCheck || (!this.branchOfficeCheck && item.officeId === this.context.office.officeId)) {
                job.salesOffice = item.officeId
                job.salesDepartment = item.departmentId
                this.loadCompanyOffice()
                break
              }
            }
          } else {
            const user = new User(data)
            const department = await user.getDefaultDepartment('role', 'sales')
            job.salesDepartment = department ? department.departmentId : 0
            const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
            if (office) {
              job.salesOffice = office.officeId
              this.txtSalesOffice = this.isZh ? office.chineseName : office.englishName
            }
          }
        }
      }
    },
    loadCompanyOffice() {
      const job = this.job
      const office = this.context.officeList.filter(p => p.officeId === job.salesOffice)[0]
      if (office) {
        this.txtSalesOffice = this.isZh ? office.chineseName : office.englishName
      } else {
        this.txtSalesOffice = ''
      }
    },
    /**
     * 非委托单(操作分公司可修改,客服跟销售分公司,根据操作分公司刷新操作、操作部门、单证)
     * 委托单(操作分公司不可修改,客服跟操作分公司,根据操作分公司刷新操作、操作部门、单证)
     * HQ单(操作分公司可修改,客服跟操作分公司,根据操作分公司刷新操作、客服、操作部门、单证)
     */
    isEntrustOrder() {
      const job = this.job
      let company = null
      if (job.customerId > 0) {
        company = this.context.companyList.find(p => p.cmpIdx === job.customerId)
      }
      if ((job.salesOffice === this.context.office.officeId && !job.trustFromJob && company && company.linkedBranchId === 0) || (job.salesOffice === 1)) {
        return false // 非委托单
      }
      return true
    },
    /**
     * 航线改变
     */
    async txtPlannerChangeHandler(data) {
      const job = this.job
      job.planner = data.value
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'airline', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === $store.getters.currentOfficeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.plannerOffice = office ? office.officeId : 0
              job.plannerDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'airline')
          job.plannerDepartment = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.plannerOffice = office ? office.officeId : 0
        }
      } else {
        job.planner = 0
        job.plannerDepartment = 0
        job.plannerOffice = 0
      }
    },
    async dcChangeHandler(data) {
      const job = this.job
      job.dc = data.value
      job.dcDepartment = 0
      job.dcOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'doc', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === $store.getters.currentOfficeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.dcOffice = office ? office.officeId : 0
              job.dcDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'doc')
          job.dcDepartment = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.dcOffice = office ? office.officeId : 0
        }
      } else {
        job.dc = 0
        job.dcDepartment = 0
        job.dcOffice = 0
      }
    },
    /**
     * 现场操作改变
     */
    async siteOpChangeHandler(data) {
      const job = this.job
      if (data.value) {
        job.siteOP = data.value
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'siteOp')
        job.siteOpDepartment = dep ? dep.departmentId : 0
      } else {
        job.siteOP = 0
        job.siteOpDepartment = 0
      }
    },
    /**
     * 操作改变
     */
    txtOPChangeHandler(user) {
      const job = this.job
      job.op = user.userId
      if (user.defaultDepId > 0) {
        job.opDepartment = user.defaultDepId
      } else {
        if (job.opOffice > 0) {
          new User(user).getUserDefaultDepartmentByOffice('role', 'op', job.opOffice).then(dep => {
            job.opDepartment = dep ? dep.departmentId : 0
          })
        } else {
          new User(user).getDefaultDepartment('role', 'op', job.opOffice).then(dep => {
            job.opDepartment = dep ? dep.departmentId : 0
          })
        }
      }
    },
    /**
     * 发货人选择
     */
    async shipperChange(data) {
      const job = this.job
      job.shipperId = data.value
      if (job.shipperId) {
        // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
        const company = new Company(data)
        const manifestAddress = await company.getManifestAddress()
        if (manifestAddress) {
          job.shipperLine1 = manifestAddress.addressLine1
          job.shipperLine2 = manifestAddress.addressLine2
          job.shipperLine3 = manifestAddress.addressLine3
          job.shipperLine4 = manifestAddress.addressLine4
          job.shipperLine5 = manifestAddress.addressLine5
          job.shipperLine6 = manifestAddress.addressLine6
          job.shipperLine7 = manifestAddress.addressLine7
        } else {
          job.shipperLine1 = ''
          job.shipperLine2 = ''
          job.shipperLine3 = ''
          job.shipperLine4 = ''
          job.shipperLine5 = ''
          job.shipperLine6 = ''
          job.shipperLine7 = ''
        }
      }
    },
    /**
   * 收货人选择
   */
    async consigneeChange(data) {
      const job = this.job
      job.consigneeId = data.value
      // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
      if (job.consigneeId) {
        const company = new Company(data)
        const manifestAddress = await company.getManifestAddress()
        if (manifestAddress) {
          job.consigneeLine1 = manifestAddress.addressLine1
          job.consigneeLine2 = manifestAddress.addressLine2
          job.consigneeLine3 = manifestAddress.addressLine3
          job.consigneeLine4 = manifestAddress.addressLine4
          job.consigneeLine5 = manifestAddress.addressLine5
          job.consigneeLine6 = manifestAddress.addressLine6
          job.consigneeLine7 = manifestAddress.addressLine7
        } else {
          job.consigneeLine1 = ''
          job.consigneeLine2 = ''
          job.consigneeLine3 = ''
          job.consigneeLine4 = ''
          job.consigneeLine5 = ''
          job.consigneeLine6 = ''
          job.consigneeLine7 = ''
        }
      }
    },
    /**
     * 通知人选择
     */
    async notifyChange(data) {
      const job = this.job
      job.notifyId = data.value
      // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
      if (job.notifyId) {
        const company = new Company(data)
        const manifestAddress = await company.getManifestAddress()
        if (manifestAddress) {
          job.notifyLine1 = manifestAddress.addressLine1
          job.notifyLine2 = manifestAddress.addressLine2
          job.notifyLine3 = manifestAddress.addressLine3
          job.notifyLine4 = manifestAddress.addressLine4
          job.notifyLine5 = manifestAddress.addressLine5
          job.notifyLine6 = manifestAddress.addressLine6
          job.notifyLine7 = manifestAddress.addressLine7
        } else {
          job.notifyLine1 = ''
          job.notifyLine2 = ''
          job.notifyLine3 = ''
          job.notifyLine4 = ''
          job.notifyLine5 = ''
          job.notifyLine6 = ''
          job.notifyLine7 = ''
        }
      }
    },
    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitShipperLine(data.shipperInfo)
      }
      if (data.consigneeInfo) {
        this.splitConsigneeLine(data.consigneeInfo)
      }
      if (data.notifyInfo) {
        this.splitNotifyLine(data.notifyInfo)
      }
    },
    mergeShipperLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.job['shipperLine' + i] || ''
        result += '\n'
      }
      result += (this.job['shipperLine7'] || '')
      return result.trimEnd()
    },
    splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.job['shipperLine' + i] = ''
      }
    },
    mergeConsigneeLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.job['consigneeLine' + i] || ''
        result += '\n'
      }
      result += (this.job['consigneeLine7'] || '')
      return result.trimEnd()
    },
    splitConsigneeLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.job['consigneeLine' + i] = ''
      }
    },
    mergeNotifyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.job['notifyLine' + i] || ''
        result += '\n'
      }
      result += (this.job['notifyLine7'] || '')
      return result.trimEnd()
    },
    splitNotifyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.job['notifyLine' + i] = ''
      }
    },
    wrapAddr(source, from, to, maxChars) {
      CargoDocUtil.sftAddrInputWrap.call(this, source, from, to, maxChars)
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    showTransitPortDialog() {
      const transitPortDialog = this.transitPortDialog
      for (const key in transitPortDialog.form) {
        transitPortDialog.form[key] = this.job[key]
      }
      transitPortDialog.visible = true
    },
    confirmTransitPort() {
      Object.assign(this.job, this.transitPortDialog.form)
      this.transitPortDialog.visible = false
    },
    cargoTerminalOperationChange(p) {
      this.job.cargoTerminalOperation = p.value
      if (!this.job.cargoTerminalOperation) {
        this.job.estimatedDeliveryDate = null
      }
    },
    loadingTermChangeHandler(data) {
      this.job.loadingTerm = data.value
      this.job.landTransportation = this.job.loadingTerm === 'DD'
      this.loadingTerm_Change('landTransportation')
    },
    selectFieldChangeHandler() {
      this.job.designationAgent = 0
      if (this.job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
        let cmp = null
        if (this.job.customerId > 0) {
          cmp = this.context.companyList.find(p => p.cmpIdx === this.job.customerId)
        }
        this.customerIdChangeHandler(cmp)
      }
      OverseaCustomerUtils.designationAgentOrCargoSourceChangeHandler(this)
    },
    /**
     * 自揽货： 选择客户，自动录入销售名字。
     * SC_CARGO_SOURCE 自揽货
     * NC_CARGO_SOURCE 指定货
     * 指定货： 选择代理，自动在销售处显示网管名字。
     */
    async getCustmerSales() {
      let cmp = null
      if (this.job.customerId > 0) {
        cmp = this.context.companyList.find(p => p.cmpIdx === this.job.customerId)
      }
      if (cmp) {
        const customerDetail = await new Company(cmp).getCustomerDetail()
        await this.loadCustomerDetailHandler(customerDetail)
      } else {
        this.salesList = null
      }
    },
    async loadCustomerDetailHandler(customerDetail) {
      // 如果开启分公司过滤参数，查出来所有分公司
      let officeSaleList = []
      if (this.salesOfficeCheck) {
        officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.$store.getters.currentOfficeId)
      }
      if (customerDetail) {
        const data = { value: 0 }
        if (customerDetail.sales > 0) {
          const salseTemp = customerDetail.sales
          const user = this.context.userList.find(p => p.userId === salseTemp)
          if (user && user.active) {
            if (this.salesOfficeCheck) {
              for (const obj of officeSaleList) {
                if (user.userId === obj.userId) {
                  data.value = salseTemp
                }
              }
            } else {
              data.value = salseTemp
            }
          }
          if (data.value > 0) {
            const usr = this.context.userList.find(p => p.userId === data.value)
            Object.assign(data, usr)
          }
        }
        // 显示销售所属分公司
        this.txtSales_changeHandler(data)
      }
    },
    /**
     * 指定货 -> 加载网管
     */
    async loadOverseaAgentDetailOwner(companyId) {
      let company = null
      if (companyId > 0) {
        company = this.context.companyList.find(p => p.cmpIdx === companyId)
      }
      if (company) {
        const overseaAgentDetail = await new Company(company).getOverseaAgentDetail()
        this.loadOverseaAgentDetailOwnerHandler(overseaAgentDetail)
      }
    },
    loadOverseaAgentDetailOwnerHandler(overseaAgentDetail) {
      const data = { value: 0 }
      if (overseaAgentDetail) {
        // 添加指定货代理等级
        const overseaAgentGrade = OverseaAgentGrade.getOverseaAgentGradeByCode(overseaAgentDetail.grade)
        if (overseaAgentGrade) {
          this.job.agentLevel = overseaAgentGrade.chineseName
        }
        const user = this.context.userList.find(p => p.userId === overseaAgentDetail.owner)
        if (user) {
          if (this.salesOfficeCheck) {
            if (user.active) {
              Object.assign(data, user)
              data.value = overseaAgentDetail.owner
            }
          } else {
            Object.assign(data, user)
            data.value = overseaAgentDetail.owner
          }
        }
      }
      this.txtSales_changeHandler(data)
    },
    async loadCustomerPortDestinationAgents() {
      if (this.job.cargoSource === CargoSource.NC_CARGO_SOURCE.code && this.job.customerId > 0) {
        const company = this.context.companyList.find(p => p.cmpIdx === this.job.customerId)
        if (company) {
          await new Company(company).getCustomerDetail()
          this.loadCustomerDetailHandler(company.customerDetail)
        }
      }
    },
    async txtDestinationAgentChangeHandler(data) {
      if (data.cmpIdx) {
        // 自动目的港代理
        if (this.job.cargoSource === CargoSource.NC_CARGO_SOURCE.code && (Number(this.context.config.get('refSelDesignationAgent')) === 1 || this.job.designationAgent === 0)) {
          const designationAgentCompany = await Company.getCompanyById(data.cmpIdx)
          if (designationAgentCompany && designationAgentCompany.designationAgent) {
            this.job.designationAgent = data.cmpIdx
          }
        }
        this.job.destinationAgent = data.cmpIdx
        CargoDocUtil.checkOverseaAgentProperties(this.job)
      } else {
        this.job.destinationAgent = 0
      }
      OverseaCustomerUtils.destinationAgentChangeHandler(this)
    },
    txtDesignationAgentChangeHandler(data) {
      this.job.designationAgent = data.value
      if (this.job.designationAgent > 0) {
        this.loadOverseaAgentDetail()
      }
      OverseaCustomerUtils.designationAgentOrCargoSourceChangeHandler(this)
    },
    /**
     * 加载指定货代理
     */
    loadOverseaAgentDetail() {
      const job = this.job
      if (job.designationAgent > 0) {
        const company = this.context.companyList.find(p => p.cmpIdx === job.designationAgent)
        if (company) {
          this.loadOverSeaResultHandler()
        }
      }
    },
    /**
     * 指定货代理 销售处显示网管名字。
     */
    loadOverSeaResultHandler() {
      if (this.job.designationAgent > 0) {
        this.loadOverseaAgentDetailOwner(this.job.designationAgent)
      }
    },
    bookingAgentChangeHandler(data) {
      if (!data.value) {
        this.job.bookingAgent = 0
        return
      }
      if (this.job.bookingAgent && parseInt(this.job.bookingAgent) > 0) {
        this.job.preBookingAgent = this.job.bookingAgent
      }
      this.context.reloadCharge = SEUtils.refreshChargeAccountId(this.job, 'bookingAgent', this.view.$t('SeaExport.BookingAgent'), this.context.modifiedData)
      this.job.bookingAgent = data.value
      if (this.job.bookingAgent > 0 && this.job.carrierId === 0) {
        if (data.airCmp) {
          this.job.carrierId = data.cmpIdx
        }
      }
    },
    voyageFlightCheckHandler(data) {
      if (this.job.voyageFlight) {
        this.job.voyageFlight = this.job.voyageFlight.trim().toUpperCase()
      }
    },
    // 计算毛重 支持英制
    async doWeightChangeHandler(openImperial) {
      if (openImperial) {
        this.job.weightContract = await JobUtils.calculateWeight(this.job.weightContractImperial)
      } else {
        this.job.weightContractImperial = await JobUtils.calculateWeight(this.job.weightContract, true)
      }
      this.weightCuageChangeHandler()
      this.job.chargeWeightImperial = await JobUtils.calculateWeight(this.job.chargeWeight, true)
    },
    // 计算体积 支持英制
    async doCuAgeChangeHandler(openImperial) {
      if (openImperial) {
        this.job.cubageContract = await JobUtils.calculateCubAge(this.job.cubAgeContractImperial)
      } else {
        this.job.cubAgeContractImperial = await JobUtils.calculateCubAge(this.job.cubageContract, true)
      }
      this.weightCuageChangeHandler()
      this.job.chargeWeightImperial = await JobUtils.calculateWeight(this.job.chargeWeight, true)
    },
    weightCuageChangeHandler() {
      this.job.chargeWeight = JobUtils.calcChargeWeight(this.job.weightContract, this.job.cubageContract, false, this.cWeightCeil === 4 ? 4 : undefined)
      const weight = isNaN(this.job.weightContract) ? 0 : this.job.weightContract
      const cubage = isNaN(this.job.cubageContract) ? 0 : this.job.cubageContract
      if (cubage) {
        this.job.densityContract = NumberUtils.ToFixed2(weight / cubage, 3)
      } else {
        this.job.densityContract = 0
      }
    },
    /**
     * 运输公司
     */
    carryingCmpChangeHandler(data) {
      const job = this.job
      job.carryingCmp = data.value
      if (job.trucking.length === 0) {
        const newData = new TruckingInfo().fillDefaultValue().getData()
        newData.loadingPortService = true
        newData.jobUuid = job.uuid
        job.trucking.push(newData)
      }
      const truckingInfo = job.trucking[0]
      truckingInfo.carryingCmp = job.carryingCmp
      if (!job.carryingCmp || job.carryingCmp === 0) {
        truckingInfo.driver = ''
        truckingInfo.driverTel = ''
      }
      this.addTruckingToModifiedSet(truckingInfo)
    },
    txtCargoInformationChangeHandler(obj) {
      this.job[obj.key] = obj.value
      this.job.cargoName = obj.englishName || ''
    },
    doorsChangeHandler() {
      const door = this.doorList.find(p => p.name === this.truckingInfo.doorName)
      if (door) {
        this.truckingInfo.doorMan = door.contact
        this.truckingInfo.doorManTel = door.phone
        this.truckingInfo.doorAddr = door.address
      }
    },
    sellingOrBuyingChangeHandler() {
      ChargeUtils.sellingOrBuyingTipHandler(this.job, this.job.chargeWeight, this.job.chargeWeight, this)
    },
    endTabHandler() {
      this.fillModel()
    },
    fillModel() {
      const model = this.job
      model.landTransportation = model.loadingTerm === 'DD'
      model.currency = ''
      if (model.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
        model.designationAgent = 0
      }
      // 默认创建门点
      if (model.landTransportation) {
        const door = this.doorList.find(p => p.name === this.truckingInfo.doorName)
        if (!door) {
          this.newDoor()
        }
      }
    },
    newDoor() {
      if (!this.job.customerId) {
        return
      }
      if (!this.truckingInfo.doorName) {
        return
      }
      // 填写内容是下拉框中的数据源
      const inputDoor = this.doorList.find(p => p.name === this.truckingInfo.doorName)
      if (inputDoor) {
        return
      }
      const cmp = this.context.companyList.find(p => p.cmpIdx === this.job.customerId)
      const door = {
        name: this.truckingInfo.doorName,
        contact: this.truckingInfo.doorMan,
        phone: this.truckingInfo.doorManTel,
        address: this.truckingInfo.doorAddr,
        companyUuid: cmp.uuid
      }
      addSites(door)
    },
    async getSubmitData() {
      await this.validateForm()
      return {
        job: this.job
      }
    },
    async validateForm() {
      if (this.job.customerId < 1) {
        throw new TabError(this.$t('CargoMsg.Cargo_ConsignationCompanyCannotBeNull'), 'tabAeBooking')
      }
      await JobUtils.checkCustomerBranchScope(this.job, 'tabAeBooking')
      await SecurityUtil.companyisActive(this.$t('SeaExport.Customer'), this.job.customerId, 'tabAeBooking')
      if (!this.job.etd) {
        throw new TabError(this.$t('CargoMsg.Cargo_DateOfDepartureCannotBeNull'), 'tabAeBooking')
      }
      if (!this.job.loadingPortCode) {
        throw new TabError(this.$t('CargoMsg.Cargo_PleaseSelectLoadingPort'), 'tabAeBooking')
      }
      if (!this.job.destinationPortCode) {
        throw new TabError(this.$t('CargoMsg.Cargo_PleaseChooseTheDestinationPort'), 'tabAeBooking')
      }
      if (this.job.cargoSource === CargoSource.NC_CARGO_SOURCE.code && this.job.designationAgent === 0) {
        throw new TabError(this.$t('CargoMsg.Cargo_DesignatedCannotBeNull'), 'tabAeBooking')
      }
      if (this.job.sales <= 0) {
        throw new TabError(this.$t('Message.SalesCannotBeNull'), 'tabAeBooking')
      }
      if (this.job.salesOffice <= 0) {
        throw new TabError(this.$t('Message.SalesBranchCompanyIsNullPleaseReSelectSales'), 'tabAeBooking')
      }
      if (this.job.salesDepartment <= 0) {
        throw new TabError(this.$t('Message.SalesDepartmentIsNullPleaseReSelectSales'), 'tabAeBooking')
      }
      for (let i = 1; i <= 4; ++i) {
        if (this.job['userDefinedField' + i].length > 512) {
          throw new TabError(this.$t('CargoMsg.Cargo_CustomizedField') + i + this.$t('Sales.CharacterTooLongPleaseAgain'), 'tabAeBooking')
        }
      }
      if (this.context.config.get('SERequirePONO') === '1' && !this.job.poNo) {
        throw new TabError(this.$t('CargoMsg.Cargo_ItemNumberCannotBeEmpty'), 'tabAeBooking')
      }
      return true
    },
    executeTask() {
      // 保存客户发运信息
      this.addrPM.job = this.job
      this.addrPM.isPortFilter = true
      this.addrPM.shipperCodeField = ''
      this.addrPM.shipperField = 'shipperLine'
      this.addrPM.consigneeCodeField = ''
      this.addrPM.consigneeField = 'consigneeLine'
      this.addrPM.notifyCodeField = ''
      this.addrPM.notifyField = 'notifyLine'
      this.addrPM.viewFromBasic = true
      if (parseInt(this.context.config.get('syncMailingAddress')) === 1) {
        this.addrPM.saveCheck()
      }
    },
    onExChangeAgentChange(data) {
      this.job.exChangeAgent = data.value
    },
    // 自定义岗位字段1
    async userDefinedRoleId1Handler(data) {
      const job = this.job
      job.userDefinedRoleId1 = data.value || 0
      job.userDefinedRoleDept1 = 0
      job.userDefinedRoleOffice1 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole1', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === $store.getters.currentOfficeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice1 = office ? office.officeId : 0
              job.userDefinedRoleDept1 = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole1')
          job.userDefinedRoleDept1 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice1 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段2
    async userDefinedRoleId2Handler(data) {
      const job = this.job
      job.userDefinedRoleId2 = data.value || 0
      job.userDefinedRoleDept2 = 0
      job.userDefinedRoleOffice2 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole2', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === $store.getters.currentOfficeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice2 = office ? office.officeId : 0
              job.userDefinedRoleDept2 = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole2')
          job.userDefinedRoleDept2 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice2 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段3
    async userDefinedRoleId3Handler(fieldData) {
      const value = fieldData.value
      // if (!$store.getters.enableFrontEndPlugin) {
      //   value = fieldData.value
      // }
      const job = this.job
      job.userDefinedRoleId3 = value || 0
      job.userDefinedRoleDept3 = 0
      job.userDefinedRoleOffice3 = 0
      if (value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole3', value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              job.userDefinedRoleDept3 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice3 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(fieldData) // !$store.getters.enableFrontEndPlugin ? new User(fieldData) : new User({ value })
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole3')
          job.userDefinedRoleDept3 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice3 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段4
    async userDefinedRoleId4Handler(fieldData) {
      const value = fieldData.value
      // if (!$store.getters.enableFrontEndPlugin) {
      //   value = fieldData.value
      // }
      const job = this.job
      job.userDefinedRoleId4 = value || 0
      job.userDefinedRoleDept4 = 0
      job.userDefinedRoleOffice4 = 0
      if (value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole4', value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              job.userDefinedRoleDept4 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice4 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(fieldData) // !$store.getters.enableFrontEndPlugin ? new User(fieldData) : new User({ value })
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole4')
          job.userDefinedRoleDept4 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice4 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段5
    async userDefinedRoleId5Handler(data) {
      const job = this.job
      job.userDefinedRoleId5 = data.value || 0
      job.userDefinedRoleDept5 = 0
      job.userDefinedRoleOffice5 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole5', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              this.job.userDefinedRoleDept5 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice5 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole5')
          job.userDefinedRoleDept5 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice5 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段6
    async userDefinedRoleId6Handler(data) {
      const job = this.job
      job.userDefinedRoleId6 = data.value || 0
      job.userDefinedRoleDept6 = 0
      job.userDefinedRoleOffice6 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole6', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              this.job.userDefinedRoleDept6 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice6 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole6')
          job.userDefinedRoleDept6 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice6 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段7
    async userDefinedRoleId7Handler(data) {
      const job = this.job
      job.userDefinedRoleId7 = data.value || 0
      job.userDefinedRoleDept7 = 0
      job.userDefinedRoleOffice7 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole7', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              this.job.userDefinedRoleDept7 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice7 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole7')
          job.userDefinedRoleDept7 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice7 = office ? office.officeId : 0
        }
      }
    },
    async cargoSalesChargeHandler(data) {
      const job = this.job
      job.cargoSalesId = data.value || 0
      job.cargoSalesDepartment = 0
      job.cargoSalesOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'salesOfGoods', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.cargoSalesOffice = office ? office.officeId : 0
              job.cargoSalesDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const department = await user.getDefaultDepartment('role', 'salesOfGoods')
          if (department) {
            job.cargoSalesDepartment = department ? department.departmentId : 0
            const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
            job.cargoSalesOffice = office ? office.officeId : 0
          }
        }
      }
    },
    async changeProject(p) {
      this.job.poNo = p.value
      this.job.projectName = p.projectName
      if (this.isProjectLinkedCustomer) {
        const company = await getPartnerByPoNo(this.job.poNo).then(res => {
          return res.data
        })
        if (company && this.job.customerId !== company.cmpIdx && company.active) {
          await this.txtCustomerId_changeHandler(company)
        }
      }
    },
    clearPoNo() {
      if (this.isProjectLinkedCustomer) {
        this.job.poNo = ''
        this.job.projectName
      }
    },
    destinationPortCodeChange(data) {
      this.job.destinationPortCode = data.value
      JobUtils.matchUserPortConfig(this, this.job, true)
      JobUtils.matchRegionWarehouseMappingConfig(this.job, null, true)
    },
    onPbProportionFocus() {
      if (this.pbProportionCheck) {
        return
      }
      this.pbProportionCheck = true
      if (!this.job.pbProportion) {
        return
      }
      const state = CommonState.getStateByCode(this.SPLIT_BUBBLE_COLLECT_ITEMS, this.job.pbProportion)
      if (!state) {
        this.job.pbProportion = 0
      }
    },
    onPbProportion2Focus() {
      if (this.pbProportion2Check) {
        return
      }
      this.pbProportion2Check = true
      if (!this.job.pbProportion2) {
        return
      }
      const state2 = CommonState.getStateByCode(this.SPLIT_BUBBLE_COLLECT_ITEMS, this.job.pbProportion2)
      if (!state2) {
        this.job.pbProportion2 = 0
      }
    },
    opOfficeChargeHandler() {
      JobUtils.opOfficeChange({ view: this, job: this.job, isRemoteBooking: true })
    },
    etdChange() {
      if (this.job.etd) {
        JobUtils.matchRegionWarehouseMappingConfig(this.job, null, true)
      }
    },
    onLoadingPortCodeChange() {
      JobUtils.matchUserPortConfig(this, this.job, true)
      JobUtils.matchRegionWarehouseMappingConfig(this.job, null, true)
    },
    onOperateTypeChange() {
      JobUtils.matchUserPortConfig(this, this.job, true)
      JobUtils.matchRegionWarehouseMappingConfig(this.job, null, true)
    },
    onCarrierIdChange() {
      JobUtils.matchUserPortConfig(this, this.job, true)
      JobUtils.matchRegionWarehouseMappingConfig(this.job, null, true)
    },
    onCustomJobTypeChange() {
      JobUtils.matchUserPortConfig(this, this.job, true)
      JobUtils.matchRegionWarehouseMappingConfig(this.job, null, true)
    },
    onCargoTypeChange() {
      JobUtils.matchUserPortConfig(this, this.job, true)
    },
    async checkNewJobCreditInfo() {
      const job = this.job
      if (this.creditOpen && StrUtils.isEmpty(job.uuid)) {
        const params = JobUtils.getCreditCheckJob(job)
        await canCreateByCreditInfoDetail(params).then(async res => {
          if (res.data > 0) {
            const msg = {
              dangerouslyUseHTMLString: true,
              message: await JobUtils.checkDateAndAmountExceeded(res.data),
              type: 'warning',
              duration: 5000
            }
            this.$message.warning(msg)
            if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
              job.designationAgent = 0
            } else {
              job.customerId = 0
            }
          }
        })
      }
    },
    cargoSouceChange() {
      JobUtils.matchUserPortConfig(this, this.job)
    }
  }
}
